module.exports = __webpack_public_path__ + "img/logo.b81904c.svg";